/**
 * 被保人資料
 * @returns
 */
const state = () => ({
    beneficiaryRelation: [
        {
            text: '本人',
            value: '1',
        },
        {
            text: '家屬',
            value: '2',
        },
        {
            text: '法定繼承人',
            value: '6',
        },
        {
            text: '配偶',
            value: '7',
        },
        {
            text: '直系親屬',
            value: '8',
        },
    ],
    pasSingleBeneficiaryRelation: [
        {
            text: '法定繼承人',
            value: '6',
        },
        {
            text: '配偶',
            value: '7',
        },
        {
            text: '直系親屬',
            value: '8',
        },
    ],
    carType: [
        { text: '自用小客車', value: '03' },
        { text: '自用小貨車', value: '04' },
        { text: '自用小客貨', value: '22' },
        { text: '公小貨車', value: '19' },
    ],
    powerType: [
        { text: '燃油機車', value: '0' },
        { text: '電動機車', value: '1' },
    ],
    motorType: [
        { text: '請選擇', value: null },
        { text: '普通重型 ( 51 C.C. ~ 250 C.C. )', value: '01' },
        { text: '輕型 ( 50 C.C. 以下 )', value: '02' },
        { text: '大型重機 ( 251 C.C. 以上 )', value: '32' },
    ],
    motorEletricType: [
        { text: '請選擇', value: null },
        { text: '電動小型輕型 ( 1.33 HP 以下)', value: '34' },
        { text: '電動普通輕型 ( 1.34 HP ~ 5 HP )', value: '02' },
        { text: '電動普通重型 ( 5.01 HP ~ 40 HP )', value: '01' },
        { text: '電動大型重型 ( 大於 40 HP )', value: '32' },
        { text: '微型電動二輪車', value: '35' },
    ],
    countries: [],
    europeans: [],
    otherCountries: [],
    depreciate: [
        { text: '15%', value: 'P' },
        { text: '20%', value: 'Q' },
        { text: '25%', value: '' },
    ],
    counties: [],
    occupation: [],
    relations: [
        { text: '請選擇', value: null },
        { text: '父母', value: '父母' },
        { text: '配偶', value: '配偶' },
        { text: '子女',value: '子女' },
        { text: '兄弟姊妹', value: '兄弟姊妹' },
        { text: '車輛使用人', value: '車輛使用人' }
    ],
    corpRelations: [
        { text: '公司負責人', value: '公司負責人' },
        { text: '僱傭', value: '僱傭' },
        { text: '債權債務關係', value: '債權債務關係' },
        { text: '其他', value: '其他' },
    ],
    riskCountryList: [], // 完整從 api-14 /Common/GetRiskCountryList 下載回來的資料
    zipData: [], // 完整從 api load 下來的 ZipData 資料
});

const actions = {};

const getters = {
    /**
     * 縣市與鄉鎮區選項
     * @param {*} state
     * @returns {Array}
     */
    getDistricts: (state) => (county) => {
        if (!county || !county.value) return [{ text: '請選擇', value: null }];
        return _.map(state.zipData[county.value], (o) => {
            return {
                text: o.Name || county.value,
                value: o.ZipCode,
            };
        });
    },
    /**
     * 國家選項
     * @param {*} state
     * @returns {Array}
     */
    getCountries: (state) => {
        let countries = [{text: '請選擇', value: null, type: null}];
        _.forEach(state.riskCountryList.Item1, c => {
            countries.push({ 
                value: c.Name,
                text: c.Name,
                type: c.Type,});
        });
        return countries;
    },
    /**
     * 歐盟國家選項
     * @param {*} state
     * @returns {Array}
     */
    getEuropeanCountries: (state) => {
        let europeanCountries = [{text: '請選擇', value: null, type: null}];
        _.forEach(state.riskCountryList.Item2, c => {
            europeanCountries.push({ 
                value: c.Name,
                text: c.Name,
                type: c.Type,});
        });
        return europeanCountries;
    },
    /**
     * 其他國家選項
     * @param {*} state
     * @returns {Array}
     */
    getOtherCountries: (state) => {
        let otherCountries = [{text: '請選擇', value: null, type: null}];
        _.forEach(state.riskCountryList.Item3, c => {
            otherCountries.push({ 
                value: c.Name,
                text: c.Name,
                type: c.Type,});
        });
        return otherCountries;       
    },
    hasLoadedCountries: (state) => {
        return state.riskCountryList.length != 0;
    },
    hasLoadedZipData: (state) => {
        return state.zipData.length != 0;
    },
    hasLoadedOccupation: (state) =>{
        return state.occupation.length != 0;
    },
    getOccupFromValue: (state) => (payload) => {
        let rtn = _.find(state.occupation, {value: payload});
        return !!rtn ? rtn : {value: payload, text: '', sort: ''};
    }
};

const mutations = {
    /**
     * 國家
     * @param {*} state
     * @param {*} payload
     */
    setCounties(state, payload) {
        state.counties = payload;
    },
    /**
     * 地址
     */
    setZipData(state, payload) {
        state.zipData = payload;
    },
    /**
     * 職業列表
     * @param {*} state
     * @param {*} payload
     */
    setOccupation(state, payload) {
        state.occupation = payload;
    },
    /**
     * 國籍風險列表
     * @param {*} state
     * @param {*} payload
     */
    setRiskCountryList(state, payload) {
        state.riskCountryList = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
